<rask-span
    size="3"
    [ngbPopover]="template"
    [ngClass]="{'placeholder-text': usePlaceHolder}"
    [disablePopover]="popoverDisabled"
    [openDelay]="300"
    [closeDelay]="300"
    triggers="mouseenter:mouseleave"
    container="body"
    popoverClass="line-wrapped-tooltip"
    ><span>{{presentationValue}}</span>
</rask-span>

<ng-template #template>
    {{ tooltipValue }}
    <ng-content></ng-content>
</ng-template>

<div #templateResult style="display: none">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</div>
